import React, { useRef, useState } from 'react'

import classnames from 'classnames'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import whiteLogo from '@kolayyolla/common/images/logo_white.svg'

import { ArrowBackIos, Close, Menu, Search } from '@mui/icons-material'
import { AppBar, useTheme, IconButton, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { TOP_BAR_HEIGHT, THICK_TOP_BAR_HEIGHT } from '../constants/sizes'

import SearchBox from './SearchBox'
import SideBar from './SideBar'

const useStyles = makeStyles((theme) => {
  const classList = {
    root: {
      width: '100%',
      textAlign: 'center',
      transition: 'all 0.3s ease-in-out 0s',
      padding: theme.spacing(0.5),
      height: TOP_BAR_HEIGHT,
      fontFamily: theme.typography.fontFamily,
      backgroundImage: theme.palette.primary.mainGradient
    },
    contanier: {
      maxWidth: 1120,
      display: 'flex',
      gap: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      left: 0,
      right: 0,
      margin: 'auto'
    },
    leftContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      flexDirection: 'row',
      justifyContent: 'center'
    },
    thickHeader: {
      height: THICK_TOP_BAR_HEIGHT,
      display: 'flex',
      alignItems: 'center'
    },
    title: {
      color: '#fff',
      fontWeight: 'bold',
      fontSize: 18,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    logo: {
      display: 'flex',
      cursor: 'pointer',
      [theme.breakpoints.down('lg')]: {
        marginLeft: theme.spacing(4)
      },
      '& img': {
        width: 125,
        height: 25
      }
    },
    authLogo: {
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      '& img': {
        width: '100%',
        maxHeight: 44
      }
    },
    drawerButton: {
      color: theme.palette.background.paper,
      marginLeft: theme.spacing(-1)
    },
    fixedDrawerButton: {
      position: 'fixed',
      left: theme.spacing(1)
    },
    linkButton: {
      fontWeight: 'bold',
      fontSize: theme.typography.fontSize - 1,
      color: theme.palette.getContrastText(theme.palette.primary.main)
    }
  }
  return classList
})

const Topbar = (params) => {
  const {
    type, position, title
  } = params
  const theme              = useTheme()
  const classes            = useStyles()
  const navigate           = useNavigate()
  const { alias, tableID } = useParams()
  const location           = useLocation()
  const isSmallScreen      = useMediaQuery((t) => t.breakpoints.down('sm'))

  const sidebarRef = useRef()

  const getUserLocation = () => {
    return JSON.parse(localStorage.getItem('mylocation'))
  }

  const MobileMainHeader = () => {
    const [showSearch, setShowSearch] = useState(false)

    return (
      <div className={classnames(classes.root)}>
        <div className={classes.contanier}>

          {
            title ? (tableID ? <div style={{ minWidth: 45 }} /> : <BackButton />) : <MenuButton />
          }

          {
            showSearch ? <SearchBox userLocation={getUserLocation()} /> : (

              title ? <div className={classes.title}>{title}</div>
                : (
                  <div className={classes.logo}>
                    <img src={whiteLogo} aria-hidden="true" alt="logo" onKeyPress={() => navigate('/')} onClick={() => navigate('/')} />
                  </div>
                  )
            )
          }

          {
            !title ? (
              <IconButton aria-label="search" onClick={() => setShowSearch((prev) => !prev)}>
                {
                  showSearch ? <Close style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }} />
                    : <Search style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }} />
                }
              </IconButton>
            ) : <div style={{ minWidth: 45 }} />
          }

        </div>

      </div>
    )
  }

  const MainHeader = () => {
    return (
      <div className={classnames(classes.root)}>
        <MenuButton fixed />

        <div className={classes.contanier}>

          <div className={classes.leftContainer}>
            <div className={classes.logo} style={{ marginLeft: theme.spacing(3) + 10 }}>
              <img src={whiteLogo} aria-hidden="true" alt="logo" onKeyPress={() => navigate('/')} onClick={() => navigate('/')} />
            </div>
          </div>

          <SearchBox userLocation={getUserLocation()} limitWidth />

        </div>
      </div>

    )
  }

  const AuthHeader = () => {
    return (
      <div className={classnames(classes.root, classes.thickHeader)}>
        <div className={classes.authLogo} onClick={() => navigate('/')}>
          <img src={whiteLogo} alt="logo" />
        </div>
      </div>
    )
  }

  const MenuButton = ({ fixed }) => (<IconButton
      aria-label="open drawer"
      edge="start"
      onClick={() => {
        sidebarRef.current.toggleDrawer()
      }}
      disableRipple
      disableFocusRipple
      disableTouchRipple
      className={classnames(classes.drawerButton, fixed && classes.fixedDrawerButton)}
    >
      <Menu />
    </IconButton>
  )

  const BackButton = () => (<IconButton
      aria-label="go back"
      disableRipple
      disableFocusRipple
      disableTouchRipple
      style={{ color: '#fff' }}
      onClick={() => {
        if (location.search.includes('p=')) {
          navigate(-1)
        } else if (alias && tableID) {
          navigate(`/${alias}`)
        } else {
          navigate('/')
        }
      }}
    >
      <ArrowBackIos />
    </IconButton>
  )

  return (
    <>
      <AppBar position={position} elevation={1} color="inherit" style={{ zIndex: 1300 }}>
        {type === 'auth' ? <AuthHeader /> : isSmallScreen ? <MobileMainHeader /> : <MainHeader />}

        {type !== 'auth' && isSmallScreen && !location.pathname.startsWith('/r/') && tableID && (
          <div style={{ padding: theme.spacing(1) }}>
            {`Menü: ${title || ''}`}
          </div>
        )}
      </AppBar>
      <SideBar ref={sidebarRef} />
    </>
  )
}

export default Topbar

Topbar.defaultProps = {
  type: 'menu',
  position: 'fixed',
  isPackageOrder: true
}
